import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { contact_number, ImageUrl } from '../../../../../../Helpers/request';
import ShowroomImg from '../../assets/images/s-1.jpg'
import { Row, Col, Container } from 'react-bootstrap';
import divider from '../../../newyork/assets/images/divider-line.png'
import dividerMobile from '../../../newyork/assets/images/divider-line-mobile.png'

import { isMobileOnly } from 'react-device-detect';
const Consult = ({type,width}) => {

    console.log("www",width)
    return (
        <section className='service_offered'>
            <Container className='container-whitebox'>
              
                <Row className="appointment-bx">
                     <Col className="col-md-7 col-12">
                        <iframe style={{borderRadius:"20px"}} src="https://www.google.com/maps/embed?pb=!3m2!1sen!2sin!4v1765957413105!5m2!1sen!2sin!6m8!1m7!1s3T98PbcD6awymOEgC1_X8w!2m2!1d43.07655399467118!2d-70.75879256575259!3f322.22324!4f0!5f0.7820865974627469" width="100%" height= {isMobileOnly ? "300px" : "450px"} frameborder="0" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                    </Col>
                    <Col className="col-md-5 col-12  d-md-block my-auto pl-md-5"> 
                        <div className="schedule-section text-left">
                            <div className="title-box2">
                                <h2 style={{fontSize:  (type==="custom" && width < 767) ? "28px": (type==="custom" && width > 767) ? "35px" : ""}} className={`${type==="custom" ? "fontFutura text-uppercase fw-600 ls1" : "title32"}`}>Consult with a Jewelry Specialist</h2>
                            </div>
                            <p className='para15'>A more thoughtful way to experience fine jewelry, built around you.<br /><br />
                                Call us at <a href={contact_number.link} style={{color:"#000"}} >{contact_number.text}</a> or make an appointment online or to schedule a personalized visit with a jewelry specialist.</p> <br />
                            <Link to="/make-an-appointment" className="btn-section">
                                <span> Schedule a virtual appointment </span></Link>
                        </div>
                    </Col>
                </Row>
                <div className='text-center'>
                  {isMobileOnly ? <img src={dividerMobile} alt="divider" className='img-fluid mt-5 img-fluid W-100' /> :<img src={divider} alt="divider" className='img-fluid W-100 m-auto' />}
                </div>
            </Container>
        </section >
    )
}

export default Consult;